import React, { useState } from 'react';
import { ConfirmationPopup, Flex, Typography } from '../components/common';
import { TYPOGRAPHY } from '../constants';
import SettingsNavigateItem from '../components/common/SettingsNavigateItem';
import { Outlet } from 'react-router-dom';

function Settings() {
  const [isLogoutConfirmation, setIsLogoutConfirmation] = useState();
  const SETTINGS_NAV_ITEMS = [
    { title: 'Account Settings', to: '/settings/account-settings' },
    {
      title: 'Notification Management',
      to: '/settings/notifications-settings',
    },
    { title: "FAQ's", to: '/settings/faq' },
    { title: 'Feedback', to: '/settings/feedback' },
    { title: 'App Preference', to: '/settings/app-preference' },
    { title: 'Privacy Policy', to: '/selttings/privacy-policy' },
    { title: 'Terms & Conditions', to: '/settings/terms-&-conditions' },
  ];

  return (
    <>
      <Flex vertical className=" pt-10 gap-6">
        <Typography text="Settings" type={TYPOGRAPHY.TITLE} />
        <Flex vertical className=" gap-4">
          {SETTINGS_NAV_ITEMS.map((item, index) => (
            <SettingsNavigateItem key={index} props={item} />
          ))}
        </Flex>
        <Outlet />
      </Flex>
    </>
  );
}

export default Settings;
